import { COMMISSIONS_ENDPOINT } from '../../endpoints'
import axios from 'axios'

export async function patchCommissionPolicy(id, body) {
  const response =  axios.put(COMMISSIONS_ENDPOINT + `/updateCommissionPolicieIncentives/${id}`, body );
  return response
}